import React from 'react';
import { TitleBar, Container, Button } from '@sencha/ext-modern';

export default function MessageTitle(props) {
    const { title, onClick } = props
    return (
        <Container>
            <TitleBar title={title} titleAlign="center" docked="top">
                <Button align="left" iconCls="x-fa fa-arrow-left" handler={onClick} />            
            </TitleBar>
        </Container>
    )
}